export const ON_LOAD_OVERVIEW_CAMPAIGN_STAT = "ON_LOAD_OVERVIEW_CAMPAIGN_STAT";
export const ON_LOAD_OVERVIEW_TODAY_STAT = "ON_LOAD_OVERVIEW_TODAY_STAT";
export const SET_OVERVIEW_TABLE_SORT = "SET_OVERVIEW_TABLE_SORT";
export const SET_OVERVIEW_DATE_RANGE = "SET_OVERVIEW_DATE_RANGE";

export const ON_LOAD_MANAGER_TOP_STAT = "ON_LOAD_MANAGER_TOP_STAT";
